import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getSellHistoryRequest,
  getSellHistorySuccess,
  getSellHistoryFailure,
  createSellRequest,
  createSellSuccess,
  createSellFailure,
} from "./sellSlice";
import { toast } from "react-toastify";

function* fetchSellHistory(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/getSellTransactions`)
    );

    if (response.data.success) {
      yield put(getSellHistorySuccess(response.data));
    } else {
      yield put(
        getSellHistoryFailure(response.data.message || "Failed to fetch notification")
      );
      toast.error(response.data.message || "Failed to fetch sell history");
    }
  } catch (error) {
    yield put(getSellHistoryFailure(error.message));
    toast.error("Error fetching sell history");
  }
}

function* createSell(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/sellMetal`,
      action.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if(response.data.success){
       yield put(createSellSuccess(response.data));
        toast.success(response.data.message || "Sell created successfully");
    }
    else{
      yield put(
        createSellFailure(response.data.message || "Failed to create sell")
      );
      toast.error(response.data.message || "Failed to create sell");
    }
  } catch (error) {
    yield put(
      createSellFailure(error.response?.data?.message || error.message)
    );
  }
}


export function* sellSaga() {
  yield takeLatest(getSellHistoryRequest.type, fetchSellHistory);
  yield takeLatest(createSellRequest.type, createSell);

}
